import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { FaCopy } from 'react-icons/fa';

const Wrap = styled.div`
  margin-bottom: 1.25rem;
`;

const Label = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.35rem;
`;

const Row = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
`;

const Input = styled.input`
  flex: 1;
  min-width: 0;
  padding: 0.55rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.82rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  background: #f9fafb;
  color: #374151;
`;

const CopyBtn = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #043663;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: #f8fafc;
  }
`;

const Hint = styled.p`
  margin: 0.35rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.4;
`;

export default function PlayerIdField({ playerId }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const value = playerId || '';

  const copy = async () => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success(t('phase2.playerProfile.toasts.playerIdCopied'));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t('phase2.playerProfile.toasts.copyFailed'));
    }
  };

  return (
    <Wrap>
      <Label>{t('phase2.playerProfile.labels.playerId')}</Label>
      <Row>
        <Input readOnly value={value} aria-label={t('phase2.playerProfile.labels.playerId')} />
        <CopyBtn type="button" onClick={copy} disabled={!value}>
          <FaCopy size={12} aria-hidden />
          {copied ? t('phase2.playerProfile.buttons.copied') : t('phase2.playerProfile.buttons.copy')}
        </CopyBtn>
      </Row>
      <Hint>{t('phase2.playerProfile.hints.playerId')}</Hint>
    </Wrap>
  );
}
